import { render, staticRenderFns } from "./team.vue?vue&type=template&id=33fefd32&scoped=true&"
import script from "./team.vue?vue&type=script&lang=js&"
export * from "./team.vue?vue&type=script&lang=js&"
import style0 from "./team.vue?vue&type=style&index=0&id=33fefd32&prod&lang=scss&scoped=true&"
import style1 from "./team.vue?vue&type=style&index=1&id=33fefd32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fefd32",
  null
  
)

export default component.exports